import { motion } from "framer-motion";
import { waLink } from "@/lib/whatsapp";

// Simple, brand-consistent WhatsApp glyph
function WhatsAppGlyph({ size = 22 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      aria-hidden
    >
      <path d="M20.52 3.48A11.9 11.9 0 0 0 12 0C5.37 0 .01 5.37.01 12c0 2.11.55 4.17 1.6 5.99L0 24l6.18-1.62A11.98 11.98 0 0 0 12 24c6.63 0 12-5.37 12-12 0-3.19-1.24-6.19-3.48-8.52ZM12 21.82a9.8 9.8 0 0 1-5-1.37l-.36-.21-3.67.96.98-3.58-.24-.37A9.83 9.83 0 1 1 21.82 12c0 5.42-4.4 9.82-9.82 9.82Zm5.4-7.36c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.66.15-.2.3-.76.96-.93 1.16-.17.2-.34.22-.63.07-.3-.15-1.27-.47-2.42-1.5a9.13 9.13 0 0 1-1.68-2.08c-.17-.3-.02-.46.13-.6.13-.13.3-.34.45-.51.15-.17.2-.29.3-.49.1-.2.05-.36-.02-.51-.07-.15-.66-1.6-.9-2.19-.24-.57-.48-.5-.66-.51h-.56c-.2 0-.51.07-.78.36-.27.3-1.02.99-1.02 2.42s1.05 2.82 1.2 3.02c.15.2 2.07 3.16 5.02 4.43.7.3 1.24.48 1.66.62.7.22 1.34.19 1.84.11.56-.08 1.75-.71 2-1.4.25-.7.25-1.28.18-1.4-.07-.11-.27-.18-.57-.33Z" />
    </svg>
  );
}

export default function WhatsAppFAB() {
  return (
    <motion.a
      href={waLink()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Chat on WhatsApp"
      initial={{ opacity: 0, scale: 0.6, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 1.8, duration: 0.6, ease: [0.65, 0, 0.35, 1] }}
      whileHover={{ scale: 1.06 }}
      whileTap={{ scale: 0.94 }}
      className="fixed bottom-6 right-6 md:bottom-8 md:right-8 z-50 group flex items-center gap-3"
    >
      {/* Pulse ring */}
      <span className="absolute inset-0 rounded-full bg-[#25D366]/40 animate-ping pointer-events-none" />

      {/* Button body */}
      <span className="relative flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] text-white shadow-[0_10px_40px_rgba(37,211,102,0.45)] border border-white/10">
        <WhatsAppGlyph size={26} />
      </span>

      {/* Editorial tooltip */}
      <span className="hidden md:flex absolute right-full mr-4 items-center whitespace-nowrap opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-500">
        <span className="bg-black/90 backdrop-blur-md border border-white/10 px-4 py-2 font-mono-label text-[10px] text-[#FDFBF7]">
          Chat with us · +91 97471 17777
        </span>
      </span>
    </motion.a>
  );
}
